<template>
  <!-- 商品收藏 -->
  <div style="padding: 30px">
    <div class="my-title">积分兑换商品</div>
    <!-- 搜索 -->
    <div class="shopp_search">
      <!-- 按钮 -->
      <div class="shopp_btn">
        <!-- <el-button size="mini">批量管理</el-button> -->
      </div>
      <!-- 搜索框 -->
      <div>
        <!-- <el-input placeholder="请输入内容" class="input-with-select">
                    <el-button slot="append">查询</el-button>
                </el-input> -->
      </div>
    </div>

    <!-- 商品  -->
    <div class="shopp_list_wp">
      <div
        class="shopp_list"
        v-for="item in shoCollectdata"
        :key="item.id"
        @click="handleInfo(item.id)"
      >
        <div class="shopp_img">
          <img :src="item.image" alt="" />
        </div>
        <div class="shopp_text">
          <span>{{ item.title }}</span>
        </div>
        <div class="sopp_price">
          <s>{{ item.original_price }}</s>
          <span>￥{{ item.price }}</span>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div class="shopp_pagination">
      <el-button
        size="small"
        style="width: 80px; height: 40px"
        @click="pervious"
        >上一页</el-button
      >
      <el-pagination
        ref="pageGroup"
        :current-page="currentPage"
        :page-size="pageSize"
        @current-change="handleCurrentChange"
        background
        layout="pager"
        :total="total"
      >
      </el-pagination>
      <el-button style="width: 80px; height: 40px" size="small" @click="next"
        >下一页</el-button
      >
    </div>
  </div>
</template>

<script>
if (localStorage.getItem("userInfo")) {
  var token = JSON.parse(localStorage.getItem("userInfo")).token;
  var header = {
    "Content-Type": "application/json",
    token: token,
    platform: "H5",
  };
}
import { scoreSkuPrice } from "@/api/index.js";
export default {
  data() {
    return {
      scoreSkuList: [],
      currentPage: 1,
      pageSize: 4,
      total: 1,
    };
  },
  created() {
    this.getScoreSku();
  },
  methods: {
    //积分兑换商品
    getScoreSku() {
      scoreSkuPrice({}).then((res) => {
        if (res.code !== 1) {
          return;
        }
        this.scoreSkuList = res.data.data;
        console.log(this.scoreSkuList);
      });
    },
    //点击商品收藏进入详情
    handleInfo(e) {
      this.$router.push({
        name: "scoreInfo",
        query: { id: e, type: "score" },
      });
    },

    //上一页
    pervious() {
      this.$refs.pageGroup.prev();
    },
    //下一页
    next() {
      this.$refs.pageGroup.next();
    },
    handleCurrentChange(newNum) {
      this.currentPage = newNum;
    },
  },
  computed: {
    shoCollectdata: function () {
      return this.scoreSkuList.slice(
        (this.currentPage - 1) * this.pageSize,
        this.currentPage * this.pageSize
      );
    },
  },
};
</script>
<style lang="less" scoped>
.my-title {
  font-size: 20px;
  padding: 0 10px;
  border-left: 5px solid #ff6701;
  margin-bottom: 10px;
  margin-left: -10px;
}
.shopp_search {
  height: 43px;
  display: flex;
  float: right;

  .shopp_btn {
    margin-right: 20px;
    display: flex;
    align-items: center;
  }
}
.shopp_list {
  width: 182px;
  height: 226px;
  background: #ffffff;
  border: 1px solid #f2f2f2;
  cursor: pointer;
  margin-right: 15px;
}
.shopp_img {
  width: 172px;
  height: 136px;
  img {
    width: 100%;
    height: 100%;
  }
}
.shopp_text {
  width: 168px;
  height: 22px;
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
}
.shopp_list_wp {
  width: 875px;
  display: flex;
  margin-top: 80px;
  .sopp_price {
    display: flex;
    padding-top: 20px;
    s {
      width: 85px;
      height: 20px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
    }
    span {
      width: 85px;
      height: 25px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ff6701;
      line-height: 25px;
    }
  }
}
.shopp_pagination {
  width: 875px;
  display: flex;
  justify-content: center;
  margin-top: 60px;
}
.el-pagination {
  padding: 0;
}
/deep/ .el-pager li {
  width: 40px !important;
  height: 40px !important;
  line-height: 40px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/index/mine/components/pointsForGoods.vue